import logo from '../logo_white.svg';
import { Link, useLocation } from 'react-router-dom';
import { openPopup } from '../utils/popupUtilities';
import { openMenuClick } from "../utils/mobNavMenuUtilities";
import VersionPopup from './popup_components/VersionPopup';
import PopupContainer from './popup_components/PopupContainer';
import OpenButton from './popup_components/OpenButton';
import Manual from '../screens/Manual'



export function openNavbar() {
  const statusbar = document.getElementById("statusbar");
  const manual = document.getElementById("manual");
  const navbar = document.getElementById("navbar");
  const pageWrapper = document.getElementById("page-wrapper");
  statusbar?.classList.add("w-10/12");
  statusbar?.classList.remove("w-full");
  navbar?.classList.add("w-2/12");
  navbar?.classList.remove("w-0");
  pageWrapper?.classList.remove("w-full");
  manual?.classList.remove("hidden");
}
export function closeNavbar() {
  const statusbar = document.getElementById("statusbar");
  const manual = document.getElementById("manual");
  const navbar = document.getElementById("navbar");
  const pageWrapper = document.getElementById("page-wrapper");
  statusbar?.classList.remove("w-10/12");
  statusbar?.classList.add("w-full");
  navbar?.classList.remove("w-2/12");
  navbar?.classList.add("w-0");
  pageWrapper?.classList.add("w-full");
  manual?.classList.add("hidden");
}

export default function Navbar() {
  const { pathname } = useLocation();

  const links = [
    { to: '/overview', text: 'Overview' },
    { to: '/sensors', text: 'Sensors' },
    { to: '/dataview', text: 'Dataview' },
    // { to: '/config-form', text: 'Sensor config' },
    { to: '/control', text: 'Control' },
    { to: '/login', text: 'Sign out' }
  ];


  return (
    <>
    <div id='navbar' className="overflow-hidden nav h-full gap-1 transition dark:bg-ndblue">
      <div className="manual">
        <a className='manual_link text-white pl-4 pt-4' id="manual"><Link to="/Manual">ⓘ Manual</Link></a>
      </div>
      <div className="nav-buttons gap-4 flex flex-col">
        {links.map(link => (
          <Link
            key={link.to} className={`navbar_link bg-white dark:bg-ngray dark:hover:bg-nred hover:cursor-pointer ${link.to === pathname || pathname === '/' && link.to === '/overview' ? 'bg-norange dark:bg-nred' : ''}`} to={link.to} >
            {link.text}
          </Link>
        ))}
      </div>
      <div className="logo w-full">
        <img className='nav-logo w-40 max-w-full self-center' src={logo} />
      </div>
      <div className="version dark:text-black text-white">
        <OpenButton text={"version "+process.env.REACT_APP_VERSION} styleClasses='ml-2 text-white font-bold text-xs version-button dark:text-black text-white' newContent={<VersionPopup />} />
        <p>iakovos.petrou@nioz.nl</p>
      </div>
    </div>
    </>
  )
}
